import { useMemo } from 'react';

import AutocompleteCFormik from './AutocompleteCFormik';
import { useQuery } from '@apollo/client/react';
import { GET_OBJECTIONS_TYPES } from 'src/api/graphql/queries/objectionsTypes.gql';

const AutocompleteCObjection = (props) => {
	// TODO: get options from server, search logic

	const { data } = useQuery(GET_OBJECTIONS_TYPES);

	const options = useMemo(() => {
		if (!data) return [];

		return data?.objectionTypes?.map(({ id, name }) => ({
			id,
			key: id,
			label: name,
		}));
	}, [data]);

	return <AutocompleteCFormik options={options} {...props} />;
};

export default AutocompleteCObjection;
